<template>
  <div>
    <el-radio-group v-model="coding"
      :disabled="disabled"
      v-if="status==='select'">
      <el-radio v-if="codingTypes.indexOf(1) > -1"
        :label="1">建批赋码</el-radio>
      <el-radio v-if="codingTypes.indexOf(2) > -1"
        :label="2">出库赋码</el-radio>
    </el-radio-group>
    <span v-else>{{codingName}}</span>
  </div>
</template>

<script>
export default {
  name: 'coding-radio-box',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'select'
    },
    value: {
      required: true
    },
    option: {
      type: Object
    }
  },
  data () {
    return {
      codingTypes: [],
      codingName: ''
    }
  },
  watch: {
    'option.vendorId': {
      handler (val, oldVal) {
        if (val && val !== oldVal) {
          this.fetchData()
        }
      }
    }
  },
  computed: {
    coding: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.codingName = val === 1 ? '建批赋码' : '出库赋码'
      }
    }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('vendor/getvendorcodingtypes', {
        payload: this.option,
        success: (res) => {
          this.codingTypes = res.data.codingTypes
          if (this.codingTypes.length === 1) {
            this.coding = this.codingTypes[0]
          }
          this.codingName = this.coding === 1 ? '建批赋码' : '出库赋码'
        },
        fail: () => {
          this.tagTypeList = []
          this.codingName = ''
        }
      })
    }
  }
}
</script>
